import { render, staticRenderFns } from "./freestyle-hurrybox.vue?vue&type=template&id=483b20ac&"
import script from "./freestyle-hurrybox.vue?vue&type=script&lang=js&"
export * from "./freestyle-hurrybox.vue?vue&type=script&lang=js&"
import style0 from "./freestyle-hurrybox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports